import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.setActiveLinks();
  }

  setActiveLinks() {
    const links = document.querySelectorAll("a.nav-link");
    const currentUrl = window.location.href;
    
    links.forEach(link => {
      const textElement = link.querySelector("p");
      const iconElement = link.querySelector("span");
      
      if (link.href === currentUrl) {
        link.classList.add("active-link");
        link.classList.add("bg-white");
        link.classList.add("lg:bg-[#E3E5EC]");
        
        link.style.color = "#002F87";
        if (textElement) textElement.style.color = "#002F87";
        if (iconElement) iconElement.classList.add("lg:text-[#002F87]");

      } else {
        link.classList.remove("active-link");
        link.classList.remove("bg-white");
        link.classList.remove("lg:bg-[#E3E5EC]");
        link.style.color = "";
        if (iconElement) iconElement.classList.remove("lg:text-[#002F87]");
        if (textElement) textElement.style.color = "";
      }
    });
  }
}
